import store from 'src/utils/store';

export const storageKey = (userUuid: string) => `discoverycard::${userUuid}`;

export function dismissCard(userUuid: string) {
  store.set(storageKey(userUuid), false);
}

export function shouldDisplayCard(userUuid: string) {
  return store.get(storageKey(userUuid)) !== false;
}
